import { FormikProvider, useFormik } from "formik";
import Title from "antd/es/typography/Title";
import { WidgetsLayout, WidgetsModal } from "pages/Dashboards/ui";
import React from "react";
import { useDashboardMainPageRequests, useModal } from "shared/hooks";
import { Page } from "shared/ui";
import { Button } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { noop } from "shared/helpers";
import { useTranslation } from "react-i18next";

const WelcomePage = () => {
  const { t } = useTranslation();
  const { dashboardsData, sortedWidgetsWithArticle } =
    useDashboardMainPageRequests({
      dashboardId: "21",
    });

  const themeColor = JSON.parse(
    localStorage.getItem("color-theme") || '"#002F5F"'
  );

  const [isOpenWidgetsModal, showWidgetsModal, hideWidgetsModal] = useModal();

  const widgetsFormik = useFormik({
    initialValues: {
      id: dashboardsData?.id,
      name: dashboardsData?.name,
      widgets: dashboardsData?.widgets ?? [],
      settings: null,
      configuration: dashboardsData?.configuration ?? [],
    },
    enableReinitialize: true,
    onSubmit: noop,
  });

  const username = localStorage.getItem("username");

  return (
    <Page title={`${t("welcome-page.title")} ${username}`} isCenteredTitle>
      <FormikProvider value={widgetsFormik}>
        <div className="w-full h-full flex">
          <WidgetsModal
            isOpen={isOpenWidgetsModal}
            onClose={hideWidgetsModal}
          />

          <div className="w-full">
            <div className="p-3.75">
              <div className="flex justify-between items-center">
                <Button
                  style={{ backgroundColor: themeColor }}
                  type="primary"
                  onClick={showWidgetsModal}
                >
                  {t("dashboards.add-widget")}
                  <PlusOutlined />
                </Button>
              </div>
            </div>
            <div className="max-h-[75vh] overflow-x-auto overflow-y-scroll">
              <div className="w-full">
                <WidgetsLayout
                  dashboardsData={dashboardsData}
                  sortedWidgetsWithArticle={sortedWidgetsWithArticle}
                />
              </div>
            </div>
            <Title className="mt-4 !text-3xl" level={5}>
              <a
                className="!text-black"
                href="https://www.chainlinx.se/"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.chainlinx.se
              </a>
            </Title>
          </div>
        </div>
      </FormikProvider>
    </Page>
  );
};

export { WelcomePage };
